/* ==============================================================================================
 * ANIMATION UTIL
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	/**
	 * @param {Element} el
	 * @param {string} name
	 * @param {number} [duration]
	 * @retun void
	 */
	Sushi.Util.animate = function (el, name, duration) {
		if (duration === undefined) {
			duration = 1000;
		}

		el.classList.add("animate");
		el.classList.add("animate--" + name);

		var timeout = setTimeout(function () {
			el.classList.remove("animate");
			el.classList.remove("animate--" + name);
			clearTimeout(timeout);
		}, duration);
	};

})(Sushi || (Sushi = {}));
